import { MealsView } from './views/meals/MealsView'
export default MealsView
